import $ from "jquery";
import {Modal} from "bootstrap";

export default function (message) {
    $("#alertModal").find(".modal-body span").html(message);
    const myModal = new Modal('#alertModal');
    myModal.show();
}
